import { TABLE_DEFAULT_COL_WIDTH } from '../../../../../../common/table/tableConstants';

const CELL_LINE_HEIGHT_GU = 2;
const CELL_VERTICAL_PADDING_GU = 0.5;

/**
 * Returns the default rendered column width for a table at the current grid size.
 */
export const getDefaultTableColWidth = (gridSize: number): number => TABLE_DEFAULT_COL_WIDTH * gridSize;

/**
 * Returns the default rendered cell line height for a table at the current grid size.
 */
export const getDefaultTableCellLineHeight = (gridSize: number): number => CELL_LINE_HEIGHT_GU * gridSize;

/**
 * Returns the default rendered cell vertical padding for a table at the current grid size.
 */
export const getDefaultTableCellVerticalPadding = (gridSize: number): number =>
    CELL_VERTICAL_PADDING_GU * gridSize - 0.5;
